import { RouteObject } from "react-router";

import FieldworkerAvailabilityScreen from "./screens/FieldworkerAvailabilityScreen";
import { FieldworkerFeedbackListScreen } from "./screens/FieldworkerFeedbackListScreen";
import {
    FieldworkerFeedbackBreadcrumb,
    FieldworkerFeedbackScreen,
} from "./screens/FieldworkerFeedbackScreen/FieldworkerFeedbackScreen";
import FieldworkerPlanningScreen from "./screens/FieldworkerPlanningScreen";
import FieldworkerShiftsScreen from "./screens/FieldworkerShiftsScreen";

export const fieldworkerRoutes: RouteObject[] = [
    {
        path: "fieldworker",
        children: [
            {
                path: "planning/:year?/:month?",
                handle: {
                    breadcrumb: "fieldworker:fieldworkerMenu.availability",
                },
                element: <FieldworkerPlanningScreen />,
            },
            {
                path: "availability",
                handle: { breadcrumb: "fieldworker:fieldworkerMenu.availability" },
                element: <FieldworkerAvailabilityScreen />,
            },
            {
                path: "shifts",
                handle: { breadcrumb: "fieldworker:fieldworkerMenu.shifts" },
                children: [{ index: true, element: <FieldworkerShiftsScreen /> }],
            },
            {
                path: "feedback",
                handle: { breadcrumb: "fieldworker:fieldworkerMenu.feedback" },
                children: [
                    { index: true, element: <FieldworkerFeedbackListScreen /> },
                    {
                        path: ":reportId",
                        handle: {
                            breadcrumb: FieldworkerFeedbackBreadcrumb,
                        },
                        element: <FieldworkerFeedbackScreen />,
                    },
                ],
            },
        ],
    },
];
